import {toast, TypeOptions} from 'react-toastify'
import React, {ReactNode, ReactText} from 'react';
import InfoIcon from '@material-ui/icons/Info';
import WarningIcon from '@material-ui/icons/Warning';
import ReportIcon from '@material-ui/icons/Report';
import SuccesIcon from '@material-ui/icons/ThumbUpAlt'

import {ToastIconComponent} from 'module/Error/component/ToastIconComponent';
import {parseServerError} from 'module/Error/util/parseServerError';
import './Toast.css'

const queue: Record<string, ReactText | undefined> = {}

function onClose(props: { name?: string }) {
	if (props.name) queue[props.name] = undefined;
}

type AutoCloseTypes = false | number;

interface IToastOptions {
	autoClose?: AutoCloseTypes
}

/**
 * @param type
 * @param content
 * @param name for detecting duplicates (set to content when content is a string and name is undefined)
 * @param opts
 */
function _toast(
	type: TypeOptions,
	content: ReactNode,
	name?: string,
	opts?: IToastOptions
) {
	if (typeof content === 'string' && !name) name = content
	let icon: ReactNode;
	switch (type) {
		case toast.TYPE.INFO:
			icon = <InfoIcon/>
			break;
		case toast.TYPE.WARNING:
			icon = <WarningIcon/>
			break;
		case toast.TYPE.SUCCESS:
			icon = <SuccesIcon/>
			break;
		case toast.TYPE.ERROR:
			icon = <ReportIcon/>
			break;
		default:
			icon = null;
	}

	let autoClose: AutoCloseTypes = false;
	if (opts && typeof opts.autoClose === 'number') autoClose = opts.autoClose;

	const comp = <ToastIconComponent name={name} icon={icon} content={content}/>;
	let toastId = name && queue[name];
	if (toastId) {
		toast.update(toastId, {
			render: comp,
			type,
		});
	} else {
		toastId = toast(comp, {
			autoClose: autoClose,
			onClose,
			type,
		})
		if (name) queue[name] = toastId
	}
	return toastId
}

export const toastMessage = (content: ReactNode, name?: string, opts?: IToastOptions) => {
	return _toast(toast.TYPE.DEFAULT, content, name, opts)
}
export const toastSuccess = (content: ReactNode, name?: string, opts?: IToastOptions) => {
	return _toast(toast.TYPE.SUCCESS, content, name, opts)
}
export const toastInfo = (content: ReactNode, name?: string, opts?: IToastOptions) => {
	return _toast(toast.TYPE.INFO, content, name, opts)
}
export const toastWarn = (content: ReactNode, name?: string, opts?: IToastOptions) => {
	return _toast(toast.TYPE.WARNING, content, name, opts)
}
export const toastError = (content: ReactNode, name?: string, opts?: IToastOptions) => {
	return _toast(toast.TYPE.ERROR, content, name, opts)
}

export const toastServerError = (error: any, prefix: string = '') => {
	if (prefix) prefix += ':\n'
	return toastError(prefix + parseServerError(error))
}
